import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { React, useEffect, useReducer, useState } from "react";
import { characterLimitConstant, textFormatConstant } from "../utils/constants";
import "./CardProductDescription.css";
import { productDescriptionReducer } from "../utils/reducer";
import OptionalTag from "./OptionalTag";

const CardProductDescription = (props) => {
  const {
    brand_name,
    product_name,
    product_description,
    collection,
    text_format,
    character_limit,
  } = props.productDescriptionState;
  const [showEditArea, setShowEditArea] = useState(false);
  const [responseValue, setResponseValue] = useState("");
  const [textFormat, setTextFormat] = useState("");
  const [characterLimit, setCharacterLimit] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [customLimit, setCustomLimit] = useState("");
  const [platform, setPlatform] = useState("");

  useEffect(() => {
    setResponseValue(props.text);
  }, [props.text]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: "15%",
      },
    },
  };
  const [state, dispatch] = useReducer(productDescriptionReducer, {
    textFormat: text_format,
    characterLimit: character_limit,
    error: false,
    helperText: "",
    customLimit: "",
    platform: platform,
    brandName: brand_name,
    productName: product_name,
    product_description: product_description,
    collectionDescription: collection,
    errors: {
      productName: false,
      brandName: false,
      productDescription: false,
      collectionDescription: false,
    },
  });

  const handleEditChange = (e) => {
    setResponseValue(e.target.value);
  };

  const handleIconClick = (e) => {
    if (!props.productDescriptionContentLocked) {
      setShowEditArea(!showEditArea);
    }
  };

  const handleContentLocked = () => {
    props.setProductDescriptionContentLocked(
      !props.productDescriptionContentLocked
    );
  };

  const inputField = (type, size, number = false) => (
    <TextField
      fullWidth
      color="tertiary"
      defaultValue=""
      focused
      multiline
      value={
        type === "custom_limit" &&
        props.productDescriptionState[type] !== "Custom Limit"
          ? props.productDescriptionState[type]
          : null
      }
      onChange={(e) => {
        let value = e.target.value;
        props.setProductDescriptionState({
          [type]: value,
        });
        if (number) {
          if (
            value === "" ||
            (Number(value) > 0 && Number(value) <= 3000 && /^\d*$/.test(value))
          ) {
            setError(false);
            setHelperText("");
          } else {
            setError(true);
            setHelperText("Please enter a valid number between 0 and 3000.");
          }
        }
      }}
      InputProps={{
        sx: {
          borderRadius: "0.4rem",
          height: size + 5,
        },
      }}
      inputProps={{
        sx: {
          overflow: "auto",
        },
        min: 1,
        max: 3000,
      }}
      type={number ? "number" : "text"}
      error={number && error}
      helperText={number && helperText}
    />
  );

  return (
    <>
      <div
        className={`bg-white h-full ${
          props.text.length && "border-2 border-gray-200 rounded-lg"
        }   relative`}
      >
        {props.text.length ? (
          <div className="flex flex-col  sm:flex-row h-72 sm:h-full my-4">
            {showEditArea ? (
              <TextField
                variant="standard"
                sx={{
                  width: "100%",
                  minHeight: "14.375rem",
                  maxHeight: "20.875rem",
                  overflowY: "auto",
                  "& fieldset": { border: "none" },
                  marginTop: "0.625rem",
                }}
                fullWidth
                multiline
                defaultValue={responseValue}
                onChange={handleEditChange}
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    color: "#000",
                    fontFamily: "Open Sans, sans-serif",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "1.875rem",
                  },
                }}
                inputRef={(input) => input && input.focus()}
                onFocus={(e) =>
                  e.currentTarget.setSelectionRange(
                    e.currentTarget.value.length,
                    e.currentTarget.value.length
                  )
                }
              />
            ) : (
              <div className="w-full overflow-auto pl-2 pr-2 pb-[0.8rem] whitespace-pre-wrap h-full leading-9 cardProductDescription">
                {responseValue}
              </div>
            )}

            <div className="sm:pl-4 flex flex-row sm:flex-col justify-around sm:justify-end items-center">
              {!showEditArea ? (
                <div>
                  <Button variant="text" onClick={handleIconClick}>
                    <img
                      src={require("../assets/edit-icon.png")}
                      className="editiconProductDescription"
                      alt="edit icon"
                    />
                  </Button>
                </div>
              ) : (
                <Button variant="text" onClick={handleIconClick}>
                  <img
                    src={require("../assets/saveIcon.png")}
                    alt="Save Icon"
                    className="saveIconProductDescription"
                  />
                </Button>
              )}

              <div>
                <Button onClick={handleContentLocked}>
                  <img
                    src={require(`../assets/${
                      props.productDescriptionContentLocked
                        ? "content-lock"
                        : "content-unlock"
                    }.jpg`)}
                    alt="locked-Icon"
                    className="lockIconProductDescription mt-4 sm:mt-0 mb-[1.06rem]"
                  />
                </Button>
              </div>

              <div>
                <Tooltip title="Send To Translate Tab">
                  
                </Tooltip>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col w-full items-center md:items-end mb-8">
            <div className="w-full h-full gap-2 flex flex-col items-center md:items-start justify-between mb-4">
              <div className="w-full flex flex-col gap-1">
                <label
                  htmlFor="brandName"
                  className="block text-sm font-medium text-gray-700"
                >
                  What is the brand name?
                </label>
                <input
                  id="brandName"
                  className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  value={state.brandName}
                  onChange={(e) => {
                    dispatch({
                      type: "UPDATE_FIELD",
                      field: "brandName",
                      value: e.target.value,
                    });
                    props.setProductDescriptionState({
                      brand_name: e.target.value,
                    });
                    if (e.target.value.length >= 500) {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "brandName",
                        value: true,
                      });
                    } else {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "brandName",
                        value: false,
                      });
                    }
                  }}
                  type="text"
                />
                {state.brandName.length >= 500 && (
                  <p className="text-red-500 text-sm">
                    Character limit exceeded
                  </p>
                )}
              </div>
              <div className="w-full flex flex-col gap-1 mt-2">
                <label
                  htmlFor="productName"
                  className="block text-sm font-medium text-gray-700"
                >
                  What is the product name?
                </label>
                <input
                  id="productName"
                  className="mt-1 block w-full p-2 border border-gray-300 rounded-md "
                  value={state.productName}
                  onChange={(e) => {
                    dispatch({
                      type: "UPDATE_FIELD",
                      field: "productName",
                      value: e.target.value,
                    });
                    props.setProductDescriptionState({
                      product_name: e.target.value,
                    });
                    if (e.target.value.length >= 500) {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "productName",
                        value: true,
                      });
                    } else {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "productName",
                        value: false,
                      });
                    }
                  }}
                  type="text"
                />
                {state.productName.length >= 500 && (
                  <p className="text-red-500 text-sm">
                    Character limit exceeded
                  </p>
                )}
              </div>
              <div className="w-full flex flex-col gap-1 mt-2">
                <label
                  htmlFor="productDescription"
                  className="block text-sm font-medium text-gray-700"
                >
                  Provide relevant product details here: (Features and Benefits)
                </label>
                <textarea
                  id="productDescription"
                  className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  value={state.productDescription}
                  onChange={(e) => {
                    props.setProductDescriptionState({
                      product_description: e.target.value,
                    });
                    dispatch({
                      type: "UPDATE_FIELD",
                      field: "product_description",
                      value: e.target.value,
                    });
                    if (e.target.value.length >= 3000) {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "productDescription",
                        value: true,
                      });
                    } else {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "productDescription",
                        value: false,
                      });
                    }
                  }}
                  rows="3"
                />
                {state.product_description.length >= 3000 && (
                  <p className="text-red-500 text-sm">
                    Character limit exceeded
                  </p>
                )}
              </div>
              <div className="w-full flex flex-col gap-1 mt-2">
                <label
                  htmlFor="collectionDescription"
                  className="block text-sm font-medium text-gray-700"
                >
                  If this product is part of a collection or product line,
                  describe the collection: <OptionalTag />
                </label>
                <textarea
                  id="collectionDescription"
                  className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  value={state.collectionDescription}
                  onChange={(e) => {
                    dispatch({
                      type: "UPDATE_FIELD",
                      field: "collectionDescription",
                      value: e.target.value,
                    });
                    props.setProductDescriptionState({
                      collection: e.target.value,
                    });
                    if (e.target.value.length >= 3000) {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "collectionDescription",
                        value: true,
                      });
                    } else {
                      dispatch({
                        type: "VALIDATE_INPUT_ERROR",
                        field: "collectionDescription",
                        value: false,
                      });
                    }
                  }}
                  rows="2"
                />
                {state.collectionDescription.length >= 3000 && (
                  <p className="text-red-500 text-sm">
                    Character limit exceeded
                  </p>
                )}
              </div>

              <div className="flex flex-col gap-2 mt-4 w-full">
                <div className="flex justify-between items-center gap-2">
                  <div className="w-[60%]">
                    <form className="w-full">
                      <label
                        htmlFor="platform"
                        className="block mb-1 text-xs font-normal text-gray-700"
                      >
                        Select the e-commerce platform this product description
                        will be published on: <OptionalTag />
                      </label>
                      <select
                        id="platform"
                        className="block w-full mt-1 border-gray-300 border px-2 py-2 rounded-md"
                        value={platform}
                        onChange={(e) => {
                          setPlatform(e.target.value);
                          props.setProductDescriptionState({
                            platform: e.target.value.toLowerCase(),
                          });
                        }}
                      >
                        <option value="" disabled={true} selected>
                          Select the Platform
                        </option>
                        {["Default", "Amazon", "Walmart", "Target"].map(
                          (value) => (
                            <option key={value} value={value}>
                              {value}
                            </option>
                          )
                        )}
                      </select>
                    </form>
                  </div>
                  <div className="w-[30%] mt-4">
                    <form className="w-full">
                      <label
                        htmlFor="textFormat"
                        className="block mb-1 text-xs font-normal text-gray-700"
                      >
                        Text Format: <OptionalTag />
                      </label>
                      <select
                        id="textFormat"
                        className={`block w-full mt-1 border-gray-300 border px-2 py-2 rounded-md`}
                        value={textFormat}
                        onChange={(e) => {
                          setTextFormat(e.target.value);
                          props.setProductDescriptionState({
                            text_format: e.target.value,
                          });
                        }}
                        disabled={platform !== "Default"}
                        style={{
                          opacity: platform !== "Default" ?  "0.2" :  "1"
                        }}
                      >
                        <option value="" disabled={true} selected>
                          Select Text Format
                        </option>
                        {platform === "Default" &&
                          textFormatConstant &&
                          textFormatConstant.map((format) => (
                            <option key={format} value={format}>
                              {format}
                            </option>
                          ))}
                      </select>
                    </form>
                  </div>
                </div>
                <div className="flex justify-between items-center gap-4">
                  <div className="w-[50%]">
                    <form className="w-full">
                      <label
                        htmlFor="characterLimit"
                        className="block mb-1 text-xs font-normal text-gray-700"
                      >
                        Character Limit: <OptionalTag />
                      </label>
                      <select
                        id="characterLimit"
                        className="block w-full mt-1 border-gray-300 border px-2 py-2 rounded-md"
                        value={characterLimit}
                        onChange={(e) => {
                          setCharacterLimit(e.target.value);
                          props.setProductDescriptionState({
                            character_limit: e.target.value,
                          });
                          if (e.target.value !== "Custom Limit") {
                            setCustomLimit("");
                            setError(false);
                          }
                        }}
                        disabled={platform !== "Default"}
                        style={{
                          opacity: platform !== "Default" ?  "0.2" :  "1"
                        }}
                      >
                        <option value="" disabled={true} selected>
                          Select Character Limit
                        </option>
                        {platform === "Default" &&
                          characterLimitConstant &&
                          Object.keys(characterLimitConstant).map(
                            (key, index) => (
                              <option key={index} value={key}>
                                {characterLimitConstant[key]}
                              </option>
                            )
                          )}
                      </select>
                    </form>
                  </div>
                  <div className="w-1/3">
                    <form className="w-full">
                      <label
                        htmlFor="customLimit"
                        className="block mb-1 text-xs font-normal text-gray-700"
                      >
                        Custom Limit: <OptionalTag />
                      </label>

                      <input
                        type="text"
                        id="customLimit"
                        className={`block w-full mt-1 border px-2 py-2 rounded-md ${
                          characterLimit !== "Custom Limit"
                            ? "cursor-not-allowed bg-gray-100"
                            : ""
                        } ${error ? "border-red-500" : "border-gray-300"}`}
                        value={customLimit}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            value === "" ||
                            (Number(value) > 0 &&
                              Number(value) <= 3000 &&
                              /^\d*$/.test(value))
                          ) {
                            setError(false);
                            setHelperText("");

                            if (characterLimit === "Custom Limit") {
                              props.setProductDescriptionState({
                                character_limit: value,
                              });
                              setCustomLimit(value);
                            }
                          } else {
                            setError(true);
                            setHelperText(
                              "Please enter a valid number between 0 and 3000."
                            );
                            setCustomLimit("");
                          }
                        }}
                        disabled={characterLimit !== "Custom Limit"}
                        style={{
                          opacity: characterLimit !== "Custom Limit" ?  "0.5" :  "1"
                        }}
                      />
                    </form>
                  </div>
                  <div className="w-1/3 mt-5">
                    <Button
                      className="submit-button-productDescription"
                      variant="outlined"
                      color="secondary"
                      fullWidth
                      disabled={
                        brand_name === "" ||
                        product_name === "" ||
                        product_description === "" ||
                        error ||
                        Object.values(state.errors).some((error) => error) ||
                        (characterLimit === "Custom Limit" &&
                          customLimit === "")
                      }
                      onClick={() => {
                        props.GeneratePromtProductDescription();
                      }}
                      sx={{
                        border: " 1px solid #26890d",
                        fontWeight: 600,
                        "&:hover": {
                          backgroundColor: "transparent",
                          borderColor: "currentColor",
                        },
                      }}
                    >
                      SUBMIT
                    </Button>
                  </div>
                </div>
                <div className="flex justify-center items-center w-full">
                  {error && characterLimit === "Custom Limit" && (
                    <p className=" w-full text-center text-sm text-red-500">
                      {helperText}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default CardProductDescription;
